import React, { useState } from 'react';
import { Avatar, Box, Container, Paper, Grow, Grid, Typography, Tabs, Tab, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { AUTH_ACTION } from '../../../interface';
import { signin, signup } from '../../../actions/auth';
import useStyles from './styles';
import useCommonStyles from '../../CommonStyle/commonStyle';
import Input from '../Input/Input';
import useMedia from "use-media";
import useCommonAuthStyles from '../commonAuthStyle';



const initialState = { email: '', password: '' };

const BetaForm = () => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const commonAuthClasses = useCommonAuthStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const [form, setForm] = useState(initialState);
    const [showPassword, setShowPassword] = useState(false);

    const onClick = () => {
        var link = "https://forms.gle/a6AF2QLrMYXnVBPA8"
        window.open(link, "_blank");
    };

    const handleShowPassword = () => setShowPassword((prevShowPassword) => (!prevShowPassword));

    const handleSubmitLogin = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log(e);
        dispatch(signin(form, history));
        console.log(JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}'));

    };


    //@ts-ignore
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, [e.target.name]: e.target.value });


    const isLarger500 = useMedia({ minWidth: "500px" });
    return (
        <Container maxWidth="lg" className={commonClasses.bodyContainer}>
            <Paper className={classes.paper} elevation={3}>
                <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={3} className={classes.parentGridContainer}>
                    <Grid item xs={12} sm={12} md={12} className={commonAuthClasses.leftGrid}>
                        <div className={classes.leftGridTypographies}>
                            <Typography className={commonAuthClasses.motivationalTitle} >
                                Flareユーザー募集<br />
                            </Typography>
                            <Typography className={classes.bodyText}>
                                <b>＜応募方法＞</b>
                                <br />
                                以下の「登録」ボタンをクリックし、フォームに必要情報をご入力ください。<br />
                                ※登録されたメールアドレスを通じて「Flare」ユーザーへの当選や開始手順などの連絡がされます。<br /><br />

                                <b>＜募集要項＞</b>
                                <br />
                                ・20歳以下 (原則高校3年生以下)<br />
                                ・社会問題解決をしたい人<br />
                                ・グループで応募される方は代表者/担当者が登録すること<br />
                                ・オンラインツールが使用できること (E-mail・Zoom・Slackを使用できるデバイスを持っている事)<br /><br />

                                <b>推奨事項</b>
                                <br />
                                ・社会問題解決に向けてプロジェクトの計画をしている人<br />
                                ・社会問題解決に向けてプロジェクトを実施している人<br /><br />

                            </Typography >
                            <Grid container spacing={7} justifyContent="center">
                                <Grid item>
                                    <Button component={Link} to="/startup" variant="contained" color="secondary" className={commonAuthClasses.submit}>
                                        戻る
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" className={commonAuthClasses.submit} onClick={onClick}>
                                        登録
                                    </Button>
                                </Grid>
                            </Grid>

                            {/* <Link to="#" className={classes.signupBtn} onClick={handleOpen}>新規登録</Link> */}
                            {/* <Button component={Link} to="www.forms.gle/a6AF2QLrMYXnVBPA8" variant="contained" color="primary" className={commonAuthClasses.submit} >
                                β版登録
                            </Button> */}
                        </div>
                    </Grid>

                </Grid>
            </Paper>
        </Container>
    )
}

export default BetaForm;
